/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Typography, Typography2, breakpoints, typography2 } from '@coursera/cds-core';
import * as cdsIcons from '@coursera/cds-icons';

import Markdown from 'bundles/cms/components/Markdown';

// iconsMap is not React component
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { iconsMap, ...icons } = cdsIcons;

const styles = {
  cardContainer: css`
    height: 100%;
    background: var(--cds-color-neutral-background-primary);
    padding: var(--cds-spacing-300);
    border-radius: 8px;
    text-align: center;
  `,
  iconContainer: css`
    margin-bottom: 5px;
  `,
  subtitleContainer: css`
    min-height: 48px;

    ${breakpoints.down('sm')} {
      min-height: auto;
    }
  `,
  markdownContainer: (theme: Theme) => css`
    .rc-Markdown.styled h3 {
      color: var(--cds-color-neutral-primary);
      ${theme.typography.h2semibold}
      margin-bottom: 5px;
    }

    .rc-Markdown.styled p {
      color: var(--cds-color-grey-600);
      ${typography2.bodyPrimary}
      margin-bottom: 0;
    }

    .rc-Markdown.styled p strong {
      color: var(--cds-color-neutral-primary);
      ${typography2.subtitleMedium}
    }
  `,
};

export type Props = {
  title?: string | null;
  subtitle?: string | null;
  description?: string | null;
  iconName?: string | null;
};

const ValuePropCard = ({ title, subtitle, description, iconName }: Props) => {
  const Icon = iconName && icons[iconName as keyof typeof icons];

  return (
    <div css={styles.cardContainer}>
      {Icon && (
        <div css={styles.iconContainer}>
          <Icon size="large" />
        </div>
      )}
      <Typography variant="h2semibold" component="p">
        {title}
      </Typography>
      <div css={styles.subtitleContainer}>
        <Typography2 component="p" variant="bodyPrimary" color="supportText">
          {subtitle}
        </Typography2>
      </div>
      {description && (
        <div css={styles.markdownContainer}>
          <hr />
          <Markdown source={description} />
        </div>
      )}
    </div>
  );
};

export default ValuePropCard;
